module.exports = __webpack_public_path__ + "img/logo.eb83570a.svg";